<script setup lang="ts">
defineProps({
    text: { type: String, default: "" }
});
</script>

<template>
    <p class="pa-1 text-primary text-body-2 text-sm-body-1" v-html="text"></p>
</template>
